import React, { FC } from 'react';

import { Button } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';

import i18n from '@/content';
import SharedFilesTable from './SharedFilesTable';
import BlockedSummaryBar from './BlockedSummaryBar';
import { ApplyRulesResponse } from '@/api/requests';
import './index.scss';

interface SharedFile {
    fid: string;
    filename: string;
    isFolder?: boolean;
    children?: SharedFile[];
    policy?: { id: string; title: string; isMfa?: boolean };
}

interface SuccessScreenProps {
    closeDrawer: () => void;
    rulesResults?: ApplyRulesResponse;
    sharedFiles?: SharedFile[];
    hideFooter?: boolean;
}

const nameSpace = 'uploadFiles.copyToClip';

const SuccessScreen: FC<SuccessScreenProps> = ({ closeDrawer, rulesResults = [], sharedFiles, hideFooter = false }) => (
    <div className="upload-drawer-sucess">
        <div className="text-block" data-testid="uploadDrawer_messageFileShared">
            <CheckCircleFilled className="success-icon" />
            <div>{i18n.t(`${nameSpace}.title`)}</div>
            <div className="text">{i18n.t(`${nameSpace}.subTitle`)}</div>
        </div>
        <SharedFilesTable rulesResults={rulesResults} sharedFiles={sharedFiles} />
        
        {!hideFooter && (
            <div className="footer-container">
                <BlockedSummaryBar rulesResults={rulesResults} />
                <div className="buttons-container">
                    <Button type="primary" className="done-button" onClick={closeDrawer} data-testid="uploadDrawer_Done">
                        {i18n.t(`${nameSpace}.done`)}
                    </Button>
                </div>
            </div>
        )}
    </div>
);

export default SuccessScreen;
